import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { GenericLinkModule } from '@spartacus/storefront'
import { EbResponsiveMediaComponent } from '../responsive-media/eb-responsive-media.component'
import { EbBannerComponent } from './eb-banner.component'

@NgModule({
  imports: [CommonModule, EbResponsiveMediaComponent, GenericLinkModule, EbBannerComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        SimpleResponsiveBannerComponent: {
          component: EbBannerComponent
        },
        BannerComponent: {
          component: EbBannerComponent
        },
        SimpleBannerComponent: {
          component: EbBannerComponent
        }
      }
    } as CmsConfig)
  ]
})
export class EbBannerModule {}
